import { TextField, useAlert } from '@frontend/mui'
import { Box, ButtonProps, FormLabel, Stack } from '@mui/material'
import debounce from 'debounce-promise'
import { useEffect, useRef, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from '@frontend/t7nd'
import {
  isEmailExistsQuery,
  sendIdentityVerifyCodeToEmailMutation,
} from 'src/generated/apollo'
import { emailValidator } from 'src/utils/validators'
import { GetCaptcha } from '../../../components/GetCaptcha'
import { FakeField } from './fake'

export const EmailMessages = {
  EMAIL_LABEL: {
    id: '邮箱',
    defaultMessage: '邮箱',
  },
  REQUIRED_FIELD: {
    id: '请填写该必填项',
    defaultMessage: '请填写该必填项',
  },
  EMAIL_NOT_EXISTS: {
    id: '该邮箱不存在',
    defaultMessage: '该邮箱不存在',
  },
  VERIFY_CODE_LABEL: {
    id: '邮箱验证码',
    defaultMessage: '邮箱验证码',
  },
  VERIFY_CODE_SENT: {
    id: '验证码已发送至邮箱，请注意查收。',
    defaultMessage: '验证码已发送至邮箱，请注意查收。',
  },
} as const

const debounceCheckEmail = debounce(isEmailExistsQuery, 500)

export function EmailFields({
  getCaptchaSize,
}: {
  getCaptchaSize?: ButtonProps['size']
}) {
  const alert = useAlert()
  const { getValues } = useFormContext()
  const [getCaptchaDisabled, setGetCaptchaDisabled] = useState<boolean>(true)
  const { watch } = useFormContext()
  const { formatMessage } = useIntl()

  useEffect(() => {
    if (!watch('email')) {
      setGetCaptchaDisabled(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch('email')])

  const focusRef = useRef<HTMLInputElement | null>(null)

  return (
    <>
      <FakeField />
      <TextField
        name="email"
        label={formatMessage(EmailMessages.EMAIL_LABEL)}
        required
        validate={async (value: string) => {
          setGetCaptchaDisabled(true)

          if (!value) {
            return formatMessage(EmailMessages.REQUIRED_FIELD)
          }
          const validMsg = emailValidator(value, formatMessage)
          if (validMsg) {
            return validMsg
          }
          const { data: existQuery } = await debounceCheckEmail({
            variables: {
              email: value,
            },
          })
          if (!existQuery.isEmailExists) {
            return formatMessage(EmailMessages.EMAIL_NOT_EXISTS)
          }

          setGetCaptchaDisabled(false)
        }}
      />
      <Stack direction="row">
        <TextField
          sx={{ marginRight: '16px' }}
          name="verifyCode"
          label={formatMessage(EmailMessages.VERIFY_CODE_LABEL)}
          required
          inputProps={{
            ref: focusRef,
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <FormLabel
            sx={{
              visibility: 'hidden',
            }}
          >
            GetCaptcha
          </FormLabel>
          <GetCaptcha
            disabled={getCaptchaDisabled}
            onClickGetCaptcha={async () => {
              const result = await sendIdentityVerifyCodeToEmailMutation({
                variables: {
                  email: getValues('email'),
                },
              })

              if (result.data?.sendIdentityVerifyCodeToEmail) {
                alert.show({
                  severity: 'success',
                  children: formatMessage(EmailMessages.VERIFY_CODE_SENT),
                })
              }
            }}
            size={getCaptchaSize}
            focusRef={focusRef}
          />
        </Box>
      </Stack>
    </>
  )
}
